import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class IdleTimeoutService {
  private timeoutDuration = environment.idleTimeout;
  private timeoutId: any;
  private readonly activityEvents = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
  private activityHandler = () => this.resetTimer();

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private toastr: ToastrService
  ) {
    this.startListening();
  }

  private startListening() {
    this.resetTimer();
    // Register high-frequency activity listeners outside Angular so they don't
    // trigger change detection on every mousemove/keydown; the handler only
    // resets a timer (onTimeout re-enters the zone via ngZone.run when needed).
    this.ngZone.runOutsideAngular(() => {
      this.activityEvents.forEach((event) =>
        window.addEventListener(event, this.activityHandler));
    });
  }

  private resetTimer() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => this.onTimeout(), this.timeoutDuration);
    });
  }

  private onTimeout() {
    this.ngZone.run(() => {
      this.toastr.error('Your session has expired, please login again.');
      this.router.navigate(['/login']);
    });
  }

  public stopListening() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.activityEvents.forEach((event) =>
      window.removeEventListener(event, this.activityHandler));
  }
}
